import DocumentForm from "./DocumentForm";

export default function NewOrgDocument() {
  return <DocumentForm ownerType="ORG" ownerId={null} returnPath="/orgDocuments" />;
}
